export default __webpack_public_path__ + "static/media/sv_9.b4827a0c.webp";